module.exports = __webpack_public_path__ + "img/Conduct.cbcbaa49.svg";